import { Grid } from 'antd';

const { useBreakpoint } = Grid;

/** Mobile = below lg (992px), aligned with MainLayout sidebar behaviour. */
export function useIsMobile(): boolean {
  const screens = useBreakpoint();
  return !screens.lg;
}
